import React from "react";
import { classNames } from "@/components/utils/functions";

export type SecondaryNavItem = {
  name: string;
  href: string;
  icon: React.ElementType;
  current: boolean;
};

export interface SecondaryNavigationProps {
  items: SecondaryNavItem[];
  onItemClick?: (item: SecondaryNavItem) => void;
}

export const SecondaryNavigation: React.FC<SecondaryNavigationProps> = ({
  items,
  onItemClick,
}) => (
  <aside className="flex overflow-x-auto border-b border-gray-900/5 py-4 lg:block lg:w-64 lg:flex-none lg:border-0 lg:py-10">
    <nav className="flex-none px-4 sm:px-6 lg:px-0">
      <ul className="flex gap-x-3 gap-y-1 whitespace-nowrap lg:flex-col">
        {items.map((item) => (
          <li key={item.name}>
            <a
              href={item.href}
              className={classNames(
                item.current
                  ? "bg-gray-50 dark:bg-gray-800 text-indigo-600"
                  : "text-gray-700 dark:text-gray-100 hover:text-indigo-600 hover:bg-gray-50 dark:hover:bg-gray-800",
                "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
              )}
              aria-current={item.current ? "page" : undefined}
              onClick={() => onItemClick?.(item)}
            >
              <item.icon
                className={classNames(
                  item.current
                    ? "text-indigo-600"
                    : "text-gray-400 group-hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-600",
                  "h-6 w-6 shrink-0"
                )}
                aria-hidden="true"
              />
              {item.name}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  </aside>
);

export default SecondaryNavigation;
